__turbopack_context__.v({
  "table": "_5GGgVW_table",
});
